const checkboxElement = document.getElementById('NewsletterCheckbox');
const submitButtonElement = document.getElementById('Subscribe');

submitButtonElement.addEventListener('click', (event) => {
  if (document.getElementById('Subscribe').classList.contains('newsletter__submitButton_disabled')) {
    event.preventDefault();
  }
});

checkboxElement.addEventListener('click', (event) => {
  const isChecked = event.target.closest('div#NewsletterCheckbox').dataset.isChecked === 'true';
  const checkedCheckboxElement = checkboxElement.querySelector('div[data-checkbox-checked]');
  const uncheckedCheckboxElement = checkboxElement.querySelector('div[data-checkbox-unchecked]');

  if (!isChecked) {
    checkedCheckboxElement.classList.remove('displayNoneImportant');
    uncheckedCheckboxElement.classList.add('displayNoneImportant');
    checkboxElement.setAttribute('data-is-checked', 'true');
    submitButtonElement.classList.remove('disabledInteractivity');
    submitButtonElement.classList.remove('newsletter__submitButton_disabled');
  } else {
    checkedCheckboxElement.classList.add('displayNoneImportant');
    uncheckedCheckboxElement.classList.remove('displayNoneImportant');
    checkboxElement.setAttribute('data-is-checked', 'false');
    submitButtonElement.classList.add('disabledInteractivity');
    submitButtonElement.classList.add('newsletter__submitButton_disabled');
  }
});

const formElement = document.getElementById('NewsletterForm');
const inputElement = document.querySelector('input.newsletter__input');
const sendFormButtonElement = document.getElementById('Subscribe');
const errorMessageContainerElement = document.getElementById('NewsletterErrorMessageContainer');
const errorInputClassName = 'newsletter__input_error';

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

const updateValidationMessage = (status) => {
  const emptyErrorMessageElement = errorMessageContainerElement.querySelector(`[data-error-type="empty"]`);
  const invalidErrorMessageElement = errorMessageContainerElement.querySelector(`[data-error-type="invalid"]`);

  switch (status) {
    case 'empty': {
      if (!inputElement.classList.contains(errorInputClassName)) {
        inputElement.classList.add(errorInputClassName);
      }

      if (emptyErrorMessageElement.classList.contains('displayNoneImportant')) {
        emptyErrorMessageElement.classList.remove('displayNoneImportant');
      }

      if (!invalidErrorMessageElement.classList.contains('displayNoneImportant')) {
        invalidErrorMessageElement.classList.add('displayNoneImportant');
      }
      break;
    }
    case 'invalid': {
      if (!inputElement.classList.contains(errorInputClassName)) {
        inputElement.classList.add(errorInputClassName);
      }

      if (invalidErrorMessageElement.classList.contains('displayNoneImportant')) {
        invalidErrorMessageElement.classList.remove('displayNoneImportant');
      }

      if (!emptyErrorMessageElement.classList.contains('displayNoneImportant')) {
        emptyErrorMessageElement.classList.add('displayNoneImportant');
      }
      break;
    }
    case 'hide': {
      if (inputElement.classList.contains(errorInputClassName)) {
        inputElement.classList.remove(errorInputClassName);
      }

      if (!invalidErrorMessageElement.classList.contains('displayNoneImportant')) {
        invalidErrorMessageElement.classList.add('displayNoneImportant');
      }

      if (!emptyErrorMessageElement.classList.contains('displayNoneImportant')) {
        emptyErrorMessageElement.classList.add('displayNoneImportant');
      }
      break;
    }
    default:
      break;
  }
}

if (inputElement) {
  inputElement.addEventListener('input', () => {
    const isInputEmpty = !inputElement.value;

    if (inputElement && isInputEmpty) {
      formElement.setAttribute('data-empty', '');
    } else if (inputElement) {
      formElement.removeAttribute('data-empty');
    }

    if (errorMessageContainerElement) {
      updateValidationMessage('hide');
    }
  });
}

if (sendFormButtonElement) {
  sendFormButtonElement.addEventListener('click', (event) => {
    event.preventDefault();

    const isEmptyInputValue = formElement.hasAttribute('data-empty');

    if (isEmptyInputValue && errorMessageContainerElement) {
      updateValidationMessage('empty');

      return;
    } else {
      const isEmailValueValid = validateEmail(inputElement.value);

      if (!isEmailValueValid && errorMessageContainerElement) {
        updateValidationMessage('invalid');

        return;
      }
    }

    formElement.submit();
  });
}
